import React from "react";
import { Slider } from "antd";
import styles from "./PeriodRange.module.css";

export default function PeriodRange({ dates, value, onChange, label = "Период" }) {
    if (!dates.length) return null;
    const start = Math.max(0, Math.min(dates.length - 1, value[0] ?? 0));
    const end = Math.max(start, Math.min(dates.length - 1, value[1] ?? dates.length - 1));
    return <fieldset className={styles.range}>
        <legend>{label}: {dates[start]} — {dates[end]}</legend>
        <div className={styles.controls}>
            <div className={styles.track}>
                <Slider range={{ draggableTrack: true }} min={0} max={Math.max(1, dates.length - 1)} step={1}
                    value={[start, end]} disabled={dates.length < 2} onChange={next => { if (next[0] !== start || next[1] !== end) onChange(next); }}
                    ariaLabelForHandle={[`${label}: начало`, `${label}: конец`]}
                    ariaValueTextFormatterForHandle={[index => dates[index], index => dates[index]]}
                    tooltip={{ formatter: index => dates[index] }} />
                <div className={styles.limits}><span>{dates[0]}</span><span>{dates.at(-1)}</span></div>
            </div>
            <button type="button" onClick={() => onChange([0, dates.length - 1])}>Весь период</button>
        </div>
    </fieldset>;
}
